import { render, staticRenderFns } from "./guoqiComp.vue?vue&type=template&id=97515944&scoped=true"
import script from "./guoqiComp.vue?vue&type=script&lang=js"
export * from "./guoqiComp.vue?vue&type=script&lang=js"
import style0 from "./guoqiComp.vue?vue&type=style&index=0&id=97515944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97515944",
  null
  
)

export default component.exports